module.exports = __webpack_public_path__ + "img/plan_nyr.735d483a.png";